import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

import AuthLayout from '../layouts/AuthLayout.vue'
import AppLayout from '../layouts/AppLayout.vue'

import RouteViewComponent from '../layouts/RouterBypass.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/:pathMatch(.*)*',
    redirect: { name: 'dashboard' },
  },
  {
    name: 'admin_login',
    path: '/authorized_users_only',
    component: () => import('../components/AppAdminLogin.vue'),
  },

  {
    name: 'admin',
    path: '/',
    component: AppLayout,
    redirect: { name: 'dashboard' },
    children: [
      {
        name: 'dashboard',
        path: 'dashboard',
        component: () => import('../pages/admin/dashboard/Dashboard.vue'),
      },
      {
        name: 'settings',
        path: 'settings',
        component: () => import('../pages/settings/Settings.vue'),
      },
      {
        name: 'seo_manager',
        path: 'seo',
        component: () => import('../pages/admin/seo/SeoManager.vue'),
      },
      // {
      //   name: 'preferences',
      //   path: 'preferences',
      //   component: () => import('../pages/preferences/Preferences.vue'),
      // },
      // {
      //   name: 'users',
      //   path: 'users',
      //   component: () => import('../pages/users/UsersPage.vue'),
      // },
      // {
      //   name: 'projects',
      //   path: 'projects',
      //   component: () => import('../pages/projects/ProjectsPage.vue'),
      // },
      // {
      //   name: 'payments',
      //   path: '/payments',
      //   component: RouteViewComponent,
      //   children: [
      //     {
      //       name: 'payment-methods',
      //       path: 'payment-methods',
      //       component: () => import('../pages/payments/PaymentsPage.vue'),
      //     },
      //     {
      //       name: 'billing',
      //       path: 'billing',
      //       component: () => import('../pages/billing/BillingPage.vue'),
      //     },
      //     {
      //       name: 'pricing-plans',
      //       path: 'pricing-plans',
      //       component: () => import('../pages/pricing-plans/PricingPlans.vue'),
      //     },
      //   ],
      // },
      {
        name: 'faq',
        path: '/faq',
        component: () => import('../pages/faq/FaqPage.vue'),
      },
      {
        name: 'main',
        path: '/faq/main',
        component: () => import('../pages/faq/pages/Main.vue'),
      },
      {
        name: 'getting_started',
        path: '/faq/getting_started',
        component: () => import('../pages/faq/pages/GettingStarted.vue'),
      },
      {
        name: 'users',
        path: '/faq/users',
        component: () => import('../pages/faq/pages/Users.vue'),
      },
      {
        name: 'users_features',
        path: '/faq/users/users_features',
        component: () => import('../pages/faq/pages/UsersFeatures.vue'),
      },
      {
        name: 'personal_acc',
        path: '/faq/users/personal_acc',
        component: () => import('../pages/faq/pages/PersonalAccount.vue'),
      },
      {
        name: 'devices',
        path: '/faq/devices',
        component: () => import('../pages/faq/pages/Devices.vue'),
      },
      {
        name: 'groups',
        path: '/faq/groups',
        component: () => import('../pages/faq/pages/Groups.vue'),
      },
      {
        name: 'groups_examples',
        path: '/faq/groups/groups_examples',
        component: () => import('../pages/faq/pages/GroupsExapmles.vue'),
      },
      {
        name: 'call_records',
        path: '/faq/call_records',
        component: () => import('../pages/faq/pages/CallRecords.vue'),
      },
      {
        name: 'voice_mail',
        path: '/faq/voice_mail',
        component: () => import('../pages/faq/pages/VoiceMail.vue'),
      },
      {
        name: 'fax',
        path: '/faq/fax',
        component: () => import('../pages/faq/pages/Fax.vue'),
      },
      {
        name: 'service_codes',
        path: '/faq/service_codes',
        component: () => import('../pages/faq/pages/ServiceCodes.vue'),
      },
      {
        name: 'statistics',
        path: '/faq/statistics',
        component: () => import('../pages/faq/pages/Statistics.vue'),
      },
      {
        name: 'parking',
        path: '/faq/service_codes/parking',
        component: () => import('../pages/faq/pages/Parking.vue'),
      },
      {
        name: 'control_by_device',
        path: '/faq/service_codes/control_by_device',
        component: () => import('../pages/faq/pages/ControlByDevice.vue'),
      },
      {
        name: 'call_pickup',
        path: '/faq/service_codes/call_pickup',
        component: () => import('../pages/faq/pages/CallPickup.vue'),
      },
      {
        name: 'call_transfer',
        path: '/faq/service_codes/call_transfer',
        component: () => import('../pages/faq/pages/CallTransfer.vue'),
      },
      {
        name: 'phone_numbers',
        path: '/faq/phone_numbers',
        component: () => import('../pages/faq/pages/PhoneNumbers.vue'),
      },
      {
        name: 'incoming_route_nums',
        path: '/faq/phone_numbers/incoming_route_nums',
        component: () => import('../pages/faq/pages/IncomingRouteNums.vue'),
      },
      {
        name: 'incoming_route_work_hours',
        path: '/faq/phone_numbers/incoming_route_work_hours',
        component: () => import('../pages/faq/pages/IncomingRouteWorkHours.vue'),
      },
      {
        name: 'incoming_route_alg',
        path: '/faq/phone_numbers/incoming_route_alg',
        component: () => import('../pages/faq/pages/IncomingRouteAlg.vue'),
      },
      {
        name: 'incoming_route_alg_new',
        path: '/faq/phone_numbers/incoming_route_alg_new',
        component: () => import('../pages/faq/pages/IncomingRouteAlgNew.vue'),
      },
      {
        name: 'auto_attendant',
        path: '/faq/phone_numbers/auto_attendant',
        component: () => import('../pages/faq/pages/AutoAttendant.vue'),
      },
      {
        name: 'hardware_instructions',
        path: '/faq/hardware_instructions',
        component: () => import('../pages/faq/pages/HardwareInstructions.vue'),
      },
      {
        name: 'need_help',
        path: '/faq/need_help',
        component: () => import('../pages/faq/pages/NeedHelp.vue'),
      },
      {
        name: 'add_devices',
        path: '/faq/users/add_devices',
        component: () => import('../pages/faq/pages/AddDevices.vue'),
      },
      {
        name: 'integrations',
        path: '/faq/integrations',
        component: () => import('../pages/faq/pages/Integrations.vue'),
      },
      {
        name: 'B24',
        path: '/faq/integrations/B24',
        component: () => import('../pages/faq/pages/B24.vue'),
      },
    ],
  },
  // {
  // path: '/auth',
  // component: AuthLayout,
  // children: [
  //   {
  //     name: 'login',
  //     path: 'login',
  //     component: () => import('../pages/auth/Login.vue'),
  //   },
  //   {
  //     name: 'signup',
  //     path: 'signup',
  //     component: () => import('../pages/auth/Signup.vue'),
  //   },
  //   {
  //     name: 'recover-password',
  //     path: 'recover-password',
  //     component: () => import('../pages/auth/RecoverPassword.vue'),
  //   },
  //   {
  //     name: 'recover-password-email',
  //     path: 'recover-password-email',
  //     component: () => import('../pages/auth/CheckTheEmail.vue'),
  //   },
  //   {
  //     path: '',
  //     redirect: { name: 'login' },
  //   },
  // ],
  // },
  {
    name: '404',
    path: '/404',
    component: () => import('../pages/404.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    // For some reason using documentation example doesn't scroll on page navigation.
    if (to.hash) {
      return { el: to.hash, behavior: 'smooth' }
    } else {
      window.scrollTo(0, 0)
    }
  },
  routes,
})

export default router
